import PaymentScheduleForm from '../../../../components/People/EmployeeLoan/Lines/PaymentScheduleForm'
import React from 'react'
import {Modal} from 'antd'
import FooterButtons from '../../../../elements/Buttons/FooterButtons'

function PaymentScheduleModal(props) {
  const {
    remove,
    submit,
    update,
    visible,
    modalType,
    formRef,
    onCancel,
    removing,
    submitting,
  } = props
  const isNew = modalType === 'new'
  return (
    <Modal
      visible={visible}
      title={'Repayment Schedule'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          submit={submit}
          remove={remove}
          update={update}
          removing={removing}
          submitting={submitting}
          title={'Repayment Schedule'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'75%'}>
      <PaymentScheduleForm ref={formRef} {...props} />
    </Modal>
  )
}

PaymentScheduleModal.propTypes = {}
PaymentScheduleModal.defaultProps = {}

export default PaymentScheduleModal
